import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import * as api from '../../../api';
import { htmlFromMarkdown } from '../../../utils/markdown';
import { SchedulingConfig } from './common';

import noAppointmentSvg from '../../../assets/no-appointment.svg';

import CallSection from './CallSection';

import styles from '../index.module.css';

interface Props {
  navigateToNextPage?: () => Promise<void>;
  practice?: api.Practice.Practice;
  encounter?: api.Encounter.Encounter;
  fieldConfig?: SchedulingConfig;
  className?: string;
}

const NoAppointments: React.FC<Props> = ({
  navigateToNextPage,
  className,
  practice,
  encounter,
  fieldConfig,
}) => {
  const { t } = useTranslation();
  const {
    helpDialog,
    previsitFormFieldId,
    scheduleAppointmentCallSectionEnabled,
  } = fieldConfig ?? {};

  return (
    <>
      {encounter?.kindOfVisit?.includes('covid') ? (
        t(
          'We no longer have any available vaccine slots, but you have been added to our waitlist. We will be contacting you to schedule once there are more availabilities.',
        )
      ) : (
        <div className={classNames([styles.NoAppointmentContent, className])}>
          <img src={noAppointmentSvg} alt={t('no appointment')} />
          <h4>{t('No appointments available')}</h4>
          {helpDialog && (
            <div
              dangerouslySetInnerHTML={{
                __html: htmlFromMarkdown(helpDialog),
              }}
            />
          )}
          {previsitFormFieldId &&
            scheduleAppointmentCallSectionEnabled &&
            navigateToNextPage &&
            practice && (
              <CallSection
                navigateToNextPage={navigateToNextPage}
                practice={practice}
                previsitFormFieldId={previsitFormFieldId}
              />
            )}
        </div>
      )}
    </>
  );
};

export default NoAppointments;
